<template>
  <Card header="Receive a recurring report">
    <img
      v-lazy="'/static/report/periodical_report.svg'"
      alt="receive a report image"
    />
    <button class="btn btn-primary" @click="onClick()">
      Set up a recurring report
    </button>
  </Card>
</template>

<script>
import Card from './index';
import GenerateReport from '../GenerateReport';
export default {
  components: { Card, GenerateReport },
  methods: {
    onClick() {
      this.$emit('onButtonClick', true);
    }
  }
};
</script>

<style lang="scss" scoped></style>
